import { connect } from 'react-redux'
import IncomingSmsDisplay from './IncomingSmsDisplay'

const stateToProps = ({ numbers }, { node }) => ({
  number: numbers.numbersById[node.extras.numberSid],
  loading: numbers.numbersLoading,
})

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(IncomingSmsDisplay)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/IncomingSms/IncomingSmsDisplay.container.js